var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6448_174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6448_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00011 11.2125C8.90011 11.2125 8.80636 11.1969 8.71886 11.1656C8.63136 11.1344 8.55011 11.0813 8.47511 11.0063L5.00636 7.5375C4.86886 7.4 4.80324 7.22813 4.80949 7.02188C4.81574 6.81563 4.88761 6.64375 5.02511 6.50625C5.16261 6.36875 5.33761 6.3 5.55011 6.3C5.76261 6.3 5.93761 6.36875 6.07511 6.50625L9.00011 9.43125L11.9439 6.4875C12.0814 6.35 12.2532 6.28438 12.4595 6.29063C12.6657 6.29688 12.8376 6.36875 12.9751 6.50625C13.1126 6.64375 13.1814 6.81875 13.1814 7.03125C13.1814 7.24375 13.1126 7.41875 12.9751 7.55625L9.52511 11.0063C9.45011 11.0813 9.36886 11.1344 9.28136 11.1656C9.19386 11.1969 9.10011 11.2125 9.00011 11.2125Z",
    fill: "#460259"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand-more.14d24e5e3635adbda2aa4084346a858d.svg";
export { ForwardRef as ReactComponent };